module.exports = __webpack_public_path__ + "static/media/remember_1.d3b00a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/remember_1.svg
// module id = 605
// module chunks = 0